<template>
  <section class="how-section">
    <div class="container">
      <h2>How it works</h2>
      <p class="subtitle">
        Simple setup for any business. Manage your team from the web while employees use the mobile app.
      </p>

      <div class="steps">
        <div class="step">
          <div class="icon">1</div>
          <h3>Create your company account</h3>
          <p>Sign up online and set up your company in minutes.</p>
        </div>

        <div class="step">
          <div class="icon">2</div>
          <h3>Add your employees</h3>
          <p>Invite employees and assign them to your organisation.</p>
        </div>

        <div class="step">
          <div class="icon">3</div>
          <h3>Employees clock in on mobile</h3>
          <p>Staff use the mobile app to clock in and out with GPS tracking.</p>
        </div>

        <div class="step">
          <div class="icon">4</div>
          <h3>Approve timesheets</h3>
          <p>Managers review and approve working hours from the dashboard.</p>
        </div>

        <div class="step">
          <div class="icon">5</div>
          <h3>Generate reports</h3>
          <p>Export timesheets and generate payroll-ready reports.</p>
        </div>
      </div>
    </div>
  </section>
</template>
<style scoped>

.how-section {
  padding: 4rem 1rem;
  background: #f9fafb;
  text-align: center;
}

.how-section h2 {
  font-size: 2rem;
  margin-bottom: 0.5rem;
}

.subtitle {
  color: #6b7280;
  margin-bottom: 2.5rem;
}

.steps {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 1.5rem;
  max-width: 1100px;
  margin: 0 auto;
}

.step {
  background: white;
  padding: 1.5rem;
  border-radius: 1rem;
  border: 1px solid #e5e7eb;
  transition: 0.2s ease;
}

.step:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(0,0,0,0.05);
}

.icon {
  width: 36px;
  height: 36px;
  background: #2563eb;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
  font-weight: bold;
}

.step h3 {
  font-size: 1rem;
  margin-bottom: 0.5rem;
}

.step p {
  font-size: 0.9rem;
  color: #6b7280;
}

/* Responsive */
@media (max-width: 900px) {
  .steps {
    grid-template-columns: 1fr;
  }
}

</style>
